import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Input as AntInput } from "antd";
import classNames from "classnames";
import "./Search.scss";
import { styleClasses } from "../../helpers";
import { Icon } from "../../particles/Icon";
const CSS_PREFIX = `lav-components-search`;
export const Search = (_a) => {
    var { className = "", size, state, rounded } = _a, antSearchProps = __rest(_a, ["className", "size", "state", "rounded"]);
    return (_jsx("div", { className: `${CSS_PREFIX}-container`, children: _jsx(AntInput.Search, Object.assign({ className: classNames(styleClasses(CSS_PREFIX, { state, size, rounded }), {
                [className]: !!className,
            }), disabled: state === "disabled", allowClear: { clearIcon: _jsx(Icon, { variant: "IconX", size: "mini" }) } }, antSearchProps)) }));
};
